import { ReactNode } from "react"

import { DownloadLinks } from "components/DownloadLinks"
import { VideoCallLocation } from "components/VideoCallLocation"
import style from "components/ContactsModal/style.module.scss"
import { Modal, Text, Headline3 } from "ui-kit/components-branded/index"
import { parsePhoneNumber } from "utils/phone-number"

interface ContactsModalProps {
    hideModal: () => void
    isModalShown: boolean
    isOffline: boolean
    location: ReactNode
    phone: string
}

export function ContactsModal({
    hideModal,
    isModalShown,
    isOffline,
    location,
    phone,
}: ContactsModalProps) {
    return (
        <Modal onBackgroundClick={hideModal} isActive={isModalShown}>
            <Modal.Content
                heading={
                    <Headline3 className={style.title}>
                        {isOffline ? "Как добраться" : <>Как подключиться к&nbsp;сессии</>}
                    </Headline3>
                }
                onCloseClick={hideModal}
                data-testid="core-how-to-connect-session-modal"
            >
                {!isOffline && (
                    <div className={style.onlineDescription}>
                        <div>
                            <Text isAccent>Сессия пройдет по&nbsp;видеосвязи.</Text>
                        </div>
                        <div>
                            <Text>
                                Напишите психологу о&nbsp;своей готовности за&nbsp;несколько минут
                                до&nbsp;начала сессии.
                            </Text>
                        </div>
                    </div>
                )}
                {!isOffline && typeof location === "string" ? (
                    <Text>
                        <VideoCallLocation address={location} />
                    </Text>
                ) : (
                    <Text>{location}</Text>
                )}
                {!isOffline && <DownloadLinks />}
                <div className={style.footer}>
                    <Text className={style.question}>Остались вопросы?</Text>
                    <div className={style.phone}>
                        <Text>Номер психолога:</Text>{" "}
                        <Text>
                            <a href={"tel:" + phone}>
                                {parsePhoneNumber(phone)?.groupedFormat || phone}
                            </a>
                        </Text>
                    </div>
                </div>
            </Modal.Content>
        </Modal>
    )
}
